import React from 'react';
import { companyInfo } from '../data/mock';

const Tagline = () => {
  return (
    <section className="bg-white py-24 px-8">
      <div className="max-w-[1000px] mx-auto text-center">
        <h2 className="text-4xl md:text-5xl leading-relaxed font-light text-black">
          {companyInfo.tagline}
        </h2>
      </div>
    </section>
  );
};

export default Tagline;